/**
 * Spacing Control Group
 *
 * Main export file for the spacing control group component.
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

// Main component
export { SpacingControl } from './component';

// Types
export type {
	EnabledSpacingControls,
	ResponsiveBreakpoint,
	SpacingAttributes,
	SpacingControlProps,
	SpacingPreset,
	SpacingSide,
	SpacingType,
	SpacingValues,
	UnitOption,
} from './types';

// Constants
export {
	boxModelColors,
	breakpointLabels,
	DEFAULT_ENABLED_CONTROLS,
	defaultPresets,
	defaultRangeSettings,
	defaultSpacingValues,
	marginPresets,
	paddingPresets,
	sideLabels,
	spacingProperties,
	unitOptions,
} from './constants';

// Utilities
export { formatSpacingValue, hasSpacingValues } from './utils';

// CSS Generation
export { getSpacingCSS } from './style';
